
export default {
    data() {
      return {
        cart_count: 0,  // 購物車數量
        cart_total: 0,  // 購物車總金額
        discount_total: 0,  // 折扣總金額
        cart_items: [],
        pay_types: [],
      }
    },
    methods: {
        pay_check(type) {
            //    debugger;
            //    console.log( JSON.stringify(this.pay_types) );
            return this.pay_types.hasOwnProperty(type);
        },
        // 加入購物車
        async add(hash, discount) {
            var res;
            try {
                res = await axios.post(this.api_url + "/add", { hash: hash, discount: discount });
                if(res.status == 200){
                    let ret = res.data;
                    if (ret.result > 0) {
                        // GA Conversion
                        // this.ga_conversion();

                        // this.get();
                        // openModal("加入購物車成功", ret.message, "了解", cancelConfirm);
                        var result = await window.Swal.fire({
                            icon: 'success',
                            title: '加入購物車成功',
                            html: ret.message,
                            showDenyButton: false,
                            showCancelButton: true,
                            confirmButtonText: '結帳去',
                            cancelButtonText: '繼續選課'
                        });

                        if ( result.isConfirmed ) {
                            location.href = '/pay/cart';
                        }

                        // that.$root.$emit('cart-changed', {});
                        this.eventBus.emit("cart-changed", {});
                    } else {
                        // console.log( ret.message );
                        // openModal("加入購物車失敗", ret.message, "了解", cancelConfirm);
                        window.Swal.fire({
                            icon: 'error',
                            title: '加入購物車失敗',
                            html: ret.message,
                            showDenyButton: false,
                            showCancelButton: false,
                            confirmButtonText: '了解'
                        });
                    }
                }
            } catch(error) {
                // console.log(error);
                const result = await window.Swal.fire({
                    icon: 'warning',
                    title: '請先登入',
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonText: '確定',
                    cancelButtonText: '取消'
                }); //.then((result) => {
                    /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {
                    location.href = '/login';
                }
                // });
            }
        },
        // 自購物車中移除
        async remove(item) {
            var res = await axios.post(this.api_url + "/remove", { id: item.id });
            if(res.status == 200){
            //    .then((res) => {
                let ret = res.data;
                if (ret.result > 0) {
                //    that.$root.$emit('cart-changed', {});
                    this.eventBus.emit("cart-changed", {});
                    // this.get();
                    // openModal("刪除購物車成功", ret.message, "了解", cancelConfirm);
                    await window.Swal.fire({
                        icon: 'success',
                        title: '刪除購物車成功',
                        html: ret.message,
                        showDenyButton: false,
                        showCancelButton: false,
                        confirmButtonText: '了解'
                    });

                }

            } else if( res.status == 401 ) {
                
                const result = await window.Swal.fire({
                    icon: 'warning',
                    title: '請先登入',
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonText: '確定',
                    cancelButtonText: '取消'
                }); //.then((result) => {
                    /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {
                    location.href = '/login';
                }
                // });
            }
            
        },
        // 轉成訂單
        async order() {
            var res = await axios.post(this.api_url + "/order");
            if(res.status == 200){
                let ret = res.data;
                if (ret.result > 0) {
                    console.log( 'order data = ' + JSON.stringify( ret ));
                    location.href = ret.data.url;
                }
            } else if( res.status == 401 ) {
                
                const result = await window.Swal.fire({
                    icon: 'warning',
                    title: '請先登入',
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonText: '確定',
                    cancelButtonText: '取消'
                }); //.then((result) => {
                    /* Read more about isConfirmed, isDenied below */
                    if (result.isConfirmed) {
                        location.href = '/login';
                    }
                // });
            }

        },
        async get(){
            try {
                var res = await axios.get(this.api_url + "/get");
                //    .then((res) => {
                if (res.status == 200) {
                    let ret = res.data;
                    //    console.log( 'add get success : ret=' + JSON.stringify( ret ));
                    if (ret.result > 0) {
                        this.cart_items = ret.data;

                        this.cart_count = this.cart_items.reduce(function (c, i) {
                            return c + i.count;
                        }, 0);

                        this.cart_total = this.cart_items.reduce(function (sum, i) {
                            if( i.discount_price ) {
                                return sum + i.price - i.discount_price;
                            } else {
                                return sum + i.price;
                            }
                        }, 0);

                        this.getPayTypes();
                    }
                } 
            } catch( e ) {
                console.log( e );
            }
        },
        async getPayTypes() {
           var res = await axios.get(this.api_url + "/pay-types");
           //     .then((res) => {
            if (res.status == 200) {
                let ret = res.data;
                //    console.log( 'add get success : ret=' + JSON.stringify( ret ));
                if (ret.result > 0) {
                    this.pay_types = ret.data;
                }
            }
        }
    },
    mounted() {
        //    console.log('menu cart mounted');
        this.get();
        // 監聽事件
        this.eventBus.on('cart-changed', (msg)=>{
            console.log('event bus (mixin cart.js): cart-changed');
            this.get();
        });
    },
};